import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import { withStyles } from "@material-ui/core/styles"

import { withTranslation } from "react-i18next"
import { compose } from "redux"

import Config from "config"
import axios from "axios"
import InputAdornment from "@material-ui/core/InputAdornment"
import Input from "components/CustomInput/CustomInput.js"

import Icon from "@material-ui/core/Icon"
import IconButton from "@material-ui/core/IconButton"

import GridContainer from "components/Grid/GridContainer.js"
import GridItem from "components/Grid/GridItem.js"
import Button from "components/CustomButtons/Button.js"

import Zoom from "@material-ui/core/Zoom"
import Dialog from "@material-ui/core/Dialog"
import DialogTitle from "@material-ui/core/DialogTitle"
import DialogContent from "@material-ui/core/DialogContent"
import DialogActions from "@material-ui/core/DialogActions"

import contactUsStyle from "assets/jss/material-kit-pro-react/views/contactUsStyle.js"

import secureStorage from "libs/secureStorage"

import CheckCircleIcon from "@material-ui/icons/CheckCircle"
import CancelIcon from "@material-ui/icons/Cancel"
import { LinearProgress, Typography, Box } from "@material-ui/core"

import zxcvbn from "zxcvbn"

import VisibilityIcon from "@material-ui/icons/Visibility"
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff"

const style = (theme) => ({
	...contactUsStyle,
	buttons: {
		marginTop: "25px",
	},
	progress: {
		height: 10,
		borderRadius: 5,
	},
	error: {
		backgroundColor: "#f44336", // red
	},
	warning: {
		backgroundColor: "#ff9800", // orange/yellow
	},
	success: {
		backgroundColor: "#4caf50", // green
	},
	inlineRule: {
		display: "inline-flex",
		alignItems: "center",
		marginRight: theme.spacing(2),
		marginBottom: theme.spacing(1),
	},
	valid: {
		color: "green",
	},
	invalid: {
		color: "red",
	},
	icon: {
		fontSize: 18,
		marginRight: 4,
	},
})
const Transition = React.forwardRef(function Transition(props, ref) {
	return <Zoom ref={ref} {...props} />
})

const rules = [
	{ label: "Min. 10 karakter", test: (pwd) => pwd.length >= 10 },
	{ label: "Huruf besar", test: (pwd) => /[A-Z]/.test(pwd) },
	{ label: "Huruf kecil", test: (pwd) => /[a-z]/.test(pwd) },
	{ label: "Angka", test: (pwd) => /[0-9]/.test(pwd) },
	{ label: "Simbol (@#$!)", test: (pwd) => /[^A-Za-z0-9]/.test(pwd) },
]
// the backend (user/changepass) checks the same rules
const passesRules = (pwd) => rules.every((rule) => rule.test(pwd))
const messageText = (data, fallback) => (typeof data === "string" && data ? data : fallback)

class ChangePassword extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			oldPass: "",
			newPass: "",
			newPassConf: "",
			confirmationModal: false,
			confirmationMessage: "",
			modalTitle: "",

			score: 0,
			progressValue: 0,
			strengthText: ["Very Weak", "Weak", "Fair", "Good", "Strong"],
			submitting: false,
			showPassword: false,
		}
	}
	componentDidMount() {}

	getBarColor = (classes) => {
		if (this.state.score <= 1) return classes.error
		if (this.state.score <= 3) return classes.warning
		return classes.success
	}

	canSave = () => {
		const { oldPass, newPass, newPassConf, submitting } = this.state
		return !submitting && !!oldPass && passesRules(newPass) && newPass === newPassConf
	}
	save = () => {
		if (!this.canSave()) return
		this.setState({ submitting: true })

		const user = secureStorage.getItem("user")
		const url = user.LoginUsers ? "/user/changepass/lu" : "/user/changepass"
		axios
			.post(Config.ApiUrl + url, {
				oldPassword: this.state.oldPass,
				newPassword: this.state.newPass,
			})
			.then((res) => {
				this.setState({
					modalTitle: "Sukses",
					confirmationMessage: messageText(res.data, "Password berhasil diubah"),
					confirmationModal: true,
					newPass: "",
					newPassConf: "",
					oldPass: "",
					submitting: false,
				})
			})
			.catch((err) => {
				this.setState({
					modalTitle: "Gagal",
					confirmationMessage: err.response
						? messageText(err.response.data, "Password gagal diubah")
						: "Koneksi jaringan terputus",
					confirmationModal: true,
					submitting: false,
				})
			})
	}
	handleSave = (e) => {
		this.save()
	}
	handleChange = (e) => {
		if (e.target.id === "oldPass") {
			this.setState({ oldPass: e.target.value })
		} else if (e.target.id === "newPass") {
			const score = zxcvbn(e.target.value).score
			const progressValue = ((score + 1) / 5) * 10

			this.setState({
				newPass: e.target.value,
				score,
				progressValue,
			})
		} else if (e.target.id === "newPassConf") {
			this.setState({ newPassConf: e.target.value })
		}
	}
	handleKeydown = (e) => {
		if (e.key === "Enter") this.save()
	}
	handleModal = (e) => {
		this.setState({ confirmationModal: false })
	}
	render() {
		const { classes, t } = this.props
		return (
			<div className={classNames(classes.main, classes.mainRaised)}>
				<div className={classes.contactContent}>
					<div className={classes.container}>
						<GridContainer justify="center" style={{ marginTop: 50 }}>
							<GridItem xl={2} lg={2} md={2} sm={12} xs={12}>
								<h4 className={classes.title}>{t("changePassword")}</h4>
							</GridItem>
							<GridItem xl={10} lg={10} md={10} sm={12} xs={12}>
								<GridContainer justify="center">
									<GridItem xl={8} lg={8} md={12} sm={12} xs={12}>
										<Input
											labelText={t("oldPassword")}
											id="oldPass"
											formControlProps={{
												fullWidth: true,
											}}
											inputProps={{
												type: this.state.showPassword ? "text" : "password",
												placeholder: `${t("type")} ${t("oldPassword")}`,
												value: this.state.oldPass,
												onChange: this.handleChange,
												startAdornment: (
													<InputAdornment position="start">
														<InputAdornment position="start">
															<Icon className={classes.inputIconsColor}>lock_utline</Icon>
														</InputAdornment>
													</InputAdornment>
												),
												endAdornment: (
													<InputAdornment position="end">
														<IconButton
															aria-label="toggle password visibility"
															onClick={() =>
																this.setState({
																	showPassword: !this.state.showPassword,
																})
															}
														>
															{this.state.showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
														</IconButton>
													</InputAdornment>
												),
											}}
										/>
									</GridItem>
									<GridItem xl={8} lg={8} md={12} sm={12} xs={12}>
										<Input
											labelText={t("newPassword")}
											id="newPass"
											formControlProps={{
												fullWidth: true,
											}}
											inputProps={{
												type: this.state.showPassword ? "text" : "password",
												placeholder: `${t("type")} ${t("newPassword")}`,
												value: this.state.newPass,
												onChange: this.handleChange,
												startAdornment: (
													<InputAdornment position="start">
														<InputAdornment position="start">
															<Icon className={classes.inputIconsColor}>lock_utline</Icon>
														</InputAdornment>
													</InputAdornment>
												),
											}}
										/>

										<Box mt={2}>
											<Typography variant="subtitle2" gutterBottom>
												Aturan Password:
											</Typography>
											<Box display="flex" flexWrap="wrap">
												{rules.map((rule, index) => {
													const isValid = rule.test(this.state.newPass)
													const RuleIcon = isValid ? CheckCircleIcon : CancelIcon

													return (
														<Box
															key={index}
															className={`${classes.inlineRule} ${isValid ? classes.valid : classes.invalid}`}
														>
															<RuleIcon className={classes.icon} />
															<Typography variant="body2">{rule.label}</Typography>
														</Box>
													)
												})}
											</Box>
										</Box>

										{this.state.newPass && (
											<>
												<Box mt={2}>
													<LinearProgress
														variant="determinate"
														value={this.state.progressValue * 10}
														classes={{
															root: classes.progress,
															barColorPrimary: this.getBarColor(classes),
														}}
														color="primary"
													/>
												</Box>
												<Typography variant="body2" style={{ marginTop: 8 }}>
													Strength: <strong>{this.state.strengthText[this.state.score]}</strong>
												</Typography>
											</>
										)}
									</GridItem>
									<GridItem xl={8} lg={8} md={12} sm={12} xs={12}>
										<Input
											labelText={t("newPasswordConfirmation")}
											id="newPassConf"
											formControlProps={{
												fullWidth: true,
											}}
											inputProps={{
												type: this.state.showPassword ? "text" : "password",
												placeholder: `${t("type")} ${t("newPassword")}`,
												value: this.state.newPassConf,
												onChange: this.handleChange,
												onKeyDown: this.handleKeydown,
												startAdornment: (
													<InputAdornment position="start">
														<InputAdornment position="start">
															<Icon className={classes.inputIconsColor}>lock_utline</Icon>
														</InputAdornment>
													</InputAdornment>
												),
											}}
										/>
										{this.state.newPassConf && this.state.newPassConf !== this.state.newPass && (
											<Typography variant="body2" className={classes.invalid}>
												Konfirmasi tidak sama dengan password baru
											</Typography>
										)}
									</GridItem>
									<GridItem xl={8} lg={8} md={12} sm={12} xs={12} style={{ textAlign: "center" }}>
										<Button
											round
											onClick={this.handleSave}
											color="facebook"
											size="lg"
											disabled={!this.canSave()}
										>
											{t("save")}
										</Button>
									</GridItem>
								</GridContainer>
							</GridItem>
						</GridContainer>
					</div>
					<Dialog
						classes={{
							root: classes.modalRoot,
							paper: classes.modal,
						}}
						open={this.state.confirmationModal}
						TransitionComponent={Transition}
						keepMounted
						//onClose={() => this.setState({successModal: false})}
						aria-labelledby="classic-modal-slide-title"
						aria-describedby="classic-modal-slide-description"
					>
						<DialogTitle id="classic-modal-slide-title" disableTypography className={classes.modalHeader}>
							<h4 className={classes.modalTitle}>{this.state.modalTitle}</h4>
						</DialogTitle>
						<DialogContent id="classic-modal-slide-description" className={classes.modalBody}>
							{this.state.confirmationMessage}
						</DialogContent>
						<DialogActions className={classes.modalFooter}>
							<Button onClick={() => this.handleModal("confirm")} color="instagram">
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			</div>
		)
	}
}
ChangePassword.propTypes = {
	classes: PropTypes.object.isRequired,
}

export default compose(withTranslation(), withStyles(style))(ChangePassword)
